<template>
  <div class="graphic-templates">
    <div
      class="graphic-templates__header"
      :class="{ 'graphic-templates__header--error': error }"
    >
      <div class="graphic-templates__details">
        <div class="graphic-templates__title">
          Archiwum
        </div>
        <div class="graphic-templates__selected">
          Wybrany projekt:
          <span
            v-if="selectedTemplate.name"
            class="primary--text font-weight-bold break-word"
          >
            {{ selectedTemplate.name }}
          </span>
          <span
            v-else
            :class="{ 'red--text font-weight-bold': error }"
          >
            BRAK
          </span>
        </div>
      </div>
      <div class="graphic-templates__actions">
        <ArchiveToolbarMenu
          archive
          @search="fetchProjects"
        />
      </div>
    </div>

    <div class="graphic-templates__tabs-items">
      <div class="graphic-templates__content">
        <template v-if="projectsList.length">
          <v-row>
            <v-col
              v-for="project in projectsList"
              :key="project.id"
              cols="12"
              md="6"
              lg="4"
            >
              <ProjectCard
                :project="project"
                class="archive-project-card"
                selectable
                :selected="isTemplateSelected(project.id, 'Project')"
                :deletable="false"
                @select="$emit('input', $event)"
              />
            </v-col>
          </v-row>

          <AppPagination
            v-if="projectsList.length"
            hide-page-options
            @change="fetchProjects"
          />
        </template>

        <AppEmptyList
          v-else
          key="emptyList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ProjectCard from '@/components/Projects/ProjectCard.vue';
import AppEmptyList from '@/components/UI/AppEmptyList.vue';
import AppPagination from '@/components/UI/AppPagination.vue';
import ArchiveToolbarMenu from '@/components/Archive/ArchivePatternToolbarMenu.vue';

export default {
  components: {
    ProjectCard,
    AppEmptyList,
    AppPagination,
    ArchiveToolbarMenu,
  },

  props: {
    value: {
      type: Number,
      default: null,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState('projects', ['projectsList']),
    selectedTemplate() {
      return this.projectsList.find((template) => template.id === this.value) || {};
    },
  },

  created() {
    this.setFilters({ statuses: ['Zaakceptowany i zarchiwizowany'] });
    this.setItemsPerPage(6).then(() => {
      this.fetchProjects();
    });
  },

  beforeDestroy() {
    this.resetPagination();
    this.clearFilters();
  },

  methods: {
    ...mapActions('pagination', ['setPage', 'setItemsPerPage', 'resetPagination']),
    ...mapActions('filters', ['setFilters', 'clearFilters']),
    ...mapActions('projects', ['fetchProjects']),

    isTemplateSelected(id, templateType) {
      return this.value === id && this.templateType === templateType;
    },
  },
};
</script>

<style lang="scss" scoped>
.graphic-templates {
  margin-bottom: 32px;

  &__header {
    background: #fff;
    box-shadow: 0px 3px 6px $shadow-key-umbra-opacity;
    margin-bottom: 8px;
    padding: 14px 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #fff;

    &--error {
      border-color: red;
    }
  }

  &__title {
    font-size: 15px;
    font-weight: 500;
    line-height: 20px;
    margin-bottom: 4px;
  }

  &__selected {
    font-size: 10px;
    line-height: 15px;
    margin-right: 16px;
  }

  &__tabs {
    background: #fff;
    box-shadow: 0px 3px 6px $shadow-key-umbra-opacity;
    padding: 0 16px;
  }

  &__tabs-items {
    margin-top: 16px;
  }
}
</style>
